var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([01b]|1s|4p|a2|ef|ft|hm|j3|lc|ot|pe|qe|qi)|n([7bimq]|[9cw]5|0k|23|2u|57|bx|do|jx|ya|ze)|2([6ep]|57|7y|86|ci|d6|g3|hd|k4)|f([46lmwx]|2j|4t|62|bm|d3|n7|ob|pr|rd|sl|to|vi|wi|wn)|q([4bx]|15|4j|5h|j7|k4|mc|v0|wy|x6|yb)|w([27jos]|0q|1v|57|77|7i|a6|cf|gz|ry|v4|wb)|z([08acgm]|51|8r|bi|dw|f4|we|x5)|o([1348oux]|4n|dj|f6|fo|hu|uh|wz|za|zc)|k([3afm]|ya(|a)|1f|1z8|4h|89|hm|q9|r2|zb)|d([5efiz]|30|cm|gb|km|nc|pi|v7)|l([bdfqru]|cd|dd|h5|iy|sj|ym)|7([adgiuw]|2[dgo]|5z|a2|db|fa|gn|j1|uw)|b([19xz]|3t|84|8f|am|bhx|kn|oc|sc|uw|vx|xt)|9([3aglq]|87|9u|be|e6|j2|ls|mq|og|p9)|r([9gjm]|02|7a|9f|hk|ku|n6|oo|q7|xd|zx)|0([459dj]|1(5|k|qp)|[aip]g|3r|aj|bc|gn|pk|q9|vb|xz)|t([cdn]|1g|3a|3w|51|7lm|a6|ah|gm|ii|l3|llv|n9|qd|qs|ty|ue|xq)|i([15kouv]|r[4iz]|99|a2|ap|b6|c0|gs|ix|kr|lh|lwb|nj|ns|wl)|x([9dlyz]|2y|4x|bv|gd|hy|jm|mx|rh|yc|zc)|h(a[58o]|1|38|4b|6|cx|g2|gj|j6|t8|up|wz|yz)|j([4ciq]|29|7g|a4|dv|pn|vb|wb|wf)|3(71|92|e|fl|j3|r4|wj|z)|s([237cglr]|0a|61|bk|d9|ex|he|hs|kd|kj|me|tz|vp)|v([79fhnpy]|k[dhn]|b3|ct|fa|n4|og|sr)|1([17fiow]|00|8m|96|f1|iz|jf|mu|qo|rv|td|x7)|8([28aw]|e[8ks]|(nm|q|x)c|1s|ad|gu|hi|hw|k2|ov|rx|w4)|g([019e]|11|xu|yb|yf|zt)|p([2ds]|3x|6o|n8|yv)|4([7hv]|17|1h|2a|76|7e|eg|ft|jx|uu|v5)|a(2r|3u|6j|7|7y|9o|ck|cv|do|f|ik|k3|rf|wv)|5([4567kmou]|0s|1p|6n|kk|rd|s9)|c([48k]|23|24|4t|8a|mi|n9|zl)|6([03coqvyz]|19|3t|3z|8y|cd|fq|gc|k5|v8|vyp)|u((|u|w)8|2l|dt|gm|hn|wq)|e([59fhlrtwz]|2b|2f|ah|av|mz|tk3|vi|vw|wo)|y(2|7n|9|ek|g7|ji|kw|l8|yi|zx))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
